import { getFrontendUrl } from "../../utils/brandingConfig";
import { appConfig } from "../../config";

export const ENVIRONMENT = {
  PRODUCTION: 'production',
};

export function getBaseUrl() {
  return getFrontendUrl();
}

export function getEnvironment() {
  return appConfig.environment || ENVIRONMENT.PRODUCTION;
}
